import { restApi } from '../../../services/Api'
import { createBasicLoopbackRepository as createRepository } from 'elentari'
import { paginate } from '../../../lib/loopback'

const flexRepository = createRepository({
  path: 'consulta-historico-viagem',
  restApi,
  queryTransform: {
    ...paginate
  }
})

flexRepository.getBySolicitacaoId = solicitacaoId => {
  return restApi.get(`consulta-historico-viagem/motorista/${solicitacaoId}`)
}

flexRepository.consultar = solicitacaoId => {
  return restApi.post(`consulta-historico-viagem/motorista/${solicitacaoId}`)
}

export default flexRepository
